/* Littos 7 Oct: record claimed gifts on the order.
   The cart drawer marks a gift row data-gift-state="added" only when the
   customer is eligible AND has clicked CLAIM. We mirror those rows into the
   cart attribute "Claimed gifts" (shown under Additional details on the order).
   The attribute is cleared when nothing is claimed / eligibility is lost. */
(function(){
  if(window.__littosGiftClaimAttr)return;
  window.__littosGiftClaimAttr=true;
  var KEY='Claimed gifts';
  var root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
  var sent=null,ready,timer;
  ready=fetch(root+'cart.js',{headers:{Accept:'application/json'}})
    .then(function(r){return r.json()})
    .then(function(c){sent=String((c.attributes&&c.attributes[KEY])||'')})
    .catch(function(){sent=''});
  function read(panel){
    var names=[];
    panel.querySelectorAll('.littos-cart2__gift-row[data-gift-state="added"] .littos-cart2__gift-name').forEach(function(n){
      var t=(n.textContent||'').trim();if(t&&names.indexOf(t)<0)names.push(t);
    });
    return names.join(', ');
  }
  function push(panel){
    clearTimeout(timer);
    timer=setTimeout(function(){
      ready.then(function(){
        var v=read(panel);
        if(v===sent)return;
        sent=v;
        var body={attributes:{}};body.attributes[KEY]=v;
        fetch(root+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(body)})
          .catch(function(){sent=null});
      });
    },250);
  }
  function init(){
    var panel=document.querySelector('[data-littos-cart2-gift-panel]');
    if(!panel)return false;
    new MutationObserver(function(){push(panel)}).observe(panel,{childList:true,subtree:true,attributes:true,attributeFilter:['data-gift-state']});
    return true;
  }
  if(!init()){var n=0,t=setInterval(function(){if(init()||++n>60)clearInterval(t)},500)}
})();
